import React from "react";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";

/*
	 Generic read-only version of a player component 
 */
class PlayerItemValueReadOnly extends React.PureComponent {

	render() {
		const { item, getImage, getVideo, getPdf } = this.props;


		let label = item.value;
		if (this.props.label) {
			label = this.props.label;
		}

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();

		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "auto" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					<div>
						{label}
					</div>
				</div>
			</div>
		);
	}
}

export default withPlayerItemHoc(PlayerItemValueReadOnly);